/**
 * components/assistant/AssistantIntro.js — /me дээрх «AI ТУСЛАХ АЖИЛЛАЖ БАЙНА» МЭДЭЭЛЭЛ.
 *
 * Хэрэглэгч (2026-11-04): «/me хэсгээс AI-г авах, харин мэдээлэл маягаар
 * танд туслахад бэлэн AI чат ажиллаж байна, яваандаа таны үнэнч туслах
 * болно, сайжирч суралцах болно».
 *
 *   • Туслах өөрөө /me-д БАЙХГҮЙ — дэлгэцийн доорх чат (AssistantChat).
 *     Энэ нь зөвхөн танилцуулга + «Чат нээх» товч.
 *   • «Ойлголоо» дарвал энэ ажилтанд дахин гарахгүй (localStorage —
 *     хувийн цонхонд ажиллахгүй бол зүгээр л дахин харагдана).
 */
import React, { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import HseAiIcon from "src/components/assistant/HseAiIcon";
import { openAssistant } from "src/components/assistant/AssistantChat";

const KEY = "assistant_intro_dismissed_v1";
const GRAD = "linear-gradient(135deg, #059669 0%, #0891B2 50%, #2563EB 100%)";

const readDismissed = () => {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export default function AssistantIntro() {
  const [hidden, setHidden] = useState(readDismissed);
  if (hidden) return null;

  const dismiss = () => {
    setHidden(true);
    try {
      window.localStorage.setItem(KEY, "1");
    } catch {
      /* хадгалах боломжгүй — дараа дахин харагдана */
    }
  };

  return (
    <div
      style={{
        position: "relative",
        border: "2px solid transparent",
        borderRadius: 14,
        backgroundImage: `linear-gradient(#fff, #fff), ${GRAD}`,
        backgroundOrigin: "border-box",
        backgroundClip: "padding-box, border-box",
        padding: "12px 40px 12px 14px",
        marginBottom: 12,
        display: "flex",
        alignItems: "center",
        gap: 14,
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          background: "#ECFEFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <HseAiIcon size={48} />
      </div>
      <div style={{ flex: 1, minWidth: 220 }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: "#1E293B" }}>
          ХАБЭА AI туслах ажиллаж байна
          <span
            style={{
              marginLeft: 8,
              fontSize: 10.5,
              fontWeight: 700,
              color: "#fff",
              background: GRAD,
              borderRadius: 999,
              padding: "2px 8px",
              verticalAlign: "middle",
            }}
          >
            ШИНЭ
          </span>
        </div>
        <div style={{ fontSize: 13, color: "#475569", marginTop: 3, lineHeight: 1.5 }}>
          Танд туслахад бэлэн AI чат дэлгэцийн баруун доод буланд байна. Өнөөдрийн ажил,
          хяналт шалгалтын хугацааны сануулга, системийн заавар, журмын асуултад хариулна.
          Яваандаа суралцаж, сайжирсаар таны үнэнч туслах болно.
        </div>
      </div>
      <button
        type="button"
        onClick={openAssistant}
        style={{
          border: "none",
          background: GRAD,
          color: "#fff",
          borderRadius: 999,
          padding: "8px 16px",
          fontWeight: 600,
          fontSize: 13,
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        Туслахтай ярилцах
      </button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Ойлголоо, нуух"
        title="Ойлголоо"
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          border: "none",
          background: "transparent",
          color: "#94A3B8",
          cursor: "pointer",
          fontSize: 13,
        }}
      >
        <CloseOutlined />
      </button>
    </div>
  );
}
